import React from 'react';
import { IconProps } from '../IconProps';
const SvgTools = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M14.445 8.444h-4.444a.67.67 0 00-.667.667.67.67 0 00.667.667h.222v3.778a1.56 1.56 0 001.555 1.555h.89a1.56 1.56 0 001.555-1.555V9.778h.222a.67.67 0 00.667-.667.67.67 0 00-.667-.667zM7.245 1.511a.663.663 0 00-.679-.018.66.66 0 00-.344.578v2.596c0 .124-.1.222-.223.222H4.222a.221.221 0 01-.223-.222V2.07a.657.657 0 00-.345-.578.643.643 0 00-.678.018A3.978 3.978 0 001.111 4.89a3.98 3.98 0 002 3.458v5.209c0 .862.698 1.555 1.556 1.555h.889c.858 0 1.555-.693 1.555-1.555v-5.21a3.98 3.98 0 002-3.457c0-1.378-.697-2.64-1.866-3.378z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.307 1.369l.445 1.556a.665.665 0 01-.062.515l-.802 1.404v2.267h-1.333V4.844l-.801-1.404a.665.665 0 01-.062-.515l.444-1.556a.666.666 0 01.641-.48h.89c.297 0 .558.196.64.48z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgTools;
